export default __webpack_public_path__ + "static/media/joao.3aa08378.jpg";